import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { useAuth } from '../auth/AuthProvider';
import { useMqtt } from '../hooks/useMqtt';
import type { Device } from '../types';

// Stable reference — prevents useMqtt's connect from re-running on every render.
const NO_DEVICES: Device[] = [];

export function Layout() {
  const { user } = useAuth();
  const [collapsed, setCollapsed] = useState(false);

  // TODO: populate from fleet API — for now empty array (MQTT won't connect)
  const { isConnected } = useMqtt(NO_DEVICES);

  return (
    <div className="min-h-screen">
      <Sidebar mqttConnected={isConnected} collapsed={collapsed} onToggle={() => setCollapsed((c) => !c)} />
      <main className={`p-6 transition-[margin] duration-200 ${collapsed ? 'ml-14' : 'ml-60'}`}>
        {/* Page header with org context */}
        <div className="mb-6 flex items-center justify-between">
          <div>
            <h1 className="text-xl font-semibold text-white">{user?.org_name}</h1>
            <p className="text-xs text-gray-500 mt-0.5 capitalize">
              {user?.org_type} &middot; {user?.tier} tier
            </p>
          </div>
        </div>
        <Outlet />
      </main>
    </div>
  );
}
